/**
 * Risolve colonne tabella da JSON (headerNameKey, omitForRoles, valueGetter preset string).
 */
export const resolveConfiguredTableColumns = (columns, t, userRoles = []) => {
    if (!Array.isArray(columns)) return [];

    return columns
        .filter((col) => {
            if (!col?.omitForRoles?.length) return true;
            return !col.omitForRoles.some((r) => userRoles.includes(r));
        })
        .map((col) => {
            const next = { ...col };
            if (col.headerNameKey) {
                next.headerName = t(col.headerNameKey);
                delete next.headerNameKey;
            }
            if (typeof col.valueGetter === 'string') {
                if (col.valueGetter === 'dateFromCell') {
                    next.valueGetter = (params) => (params ? new Date(params) : null);
                } else if (col.valueGetter === 'percentSuffix') {
                    next.valueGetter = (params) => (params != null ? `${params}%` : null);
                }
            }
            delete next.omitForRoles;
            return next;
        });
};
